import { http, HttpResponse } from 'msw'

import { allOrders } from '@/mocks/data/transactions/orders'

import { isNumeric } from '@/utils/app/number'
import { api } from '@/utils/constants'

import { OrdersRequest } from '@/types/operations/order'

export const getAllOrders = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.operations.orders.LIST}`,
    ({ request }) => {
        const url = new URL(request.url)

        const limitQuery = url.searchParams.get('limit')
        const offsetQuery = url.searchParams.get('offset')
        const phoneNumberQuery = url.searchParams.get('phone_number')
        const statusQuery = url.searchParams.get('status')

        let ordersFiltered = allOrders

        // Status filter
        if (statusQuery) {
            const statusSplit = statusQuery.split(',')

            ordersFiltered = allOrders.filter((order) =>
                statusSplit.includes(order.status),
            )
        }

        // Phone number filter
        if (phoneNumberQuery)
            ordersFiltered = allOrders.filter(
                (order) =>
                    'phone_number' in order &&
                    order.phone_number === phoneNumberQuery,
            )

        // Pagination
        const limit = isNumeric(limitQuery) ? Number(limitQuery) : 10
        const offset = isNumeric(offsetQuery) ? Number(offsetQuery) : 0

        const limitArray = Math.min(ordersFiltered.length, offset + limit)
        const results = ordersFiltered.slice(offset, limitArray)

        const next =
            offset + results.length < ordersFiltered.length
                ? 'again'
                : undefined

        return HttpResponse.json<OrdersRequest>({
            next,
            results,
        })
    },
)
